import {
  NOTIF_SET_ADMIN_LATEST,
  NOTIF_SET_ADMIN_DATA,
  NOTIF_SET_ADMIN_UNREAD,
  NOTIF_SET_ADMIN_PAGINATED_DATA,
  NOTIF_SET_ADMIN_CURRENT_PAGE,
  NOTIF_SET_ADMIN_LAST_PAGE,
  NOTIF_SET_ADMIN_SCROLL_POSITION,
  NOTIF_SET_USER_LATEST,
  NOTIF_SET_USER_DATA,
  NOTIF_SET_USER_UNREAD,
  NOTIF_SET_USER_PAGINATED_DATA,
  NOTIF_SET_USER_CURRENT_PAGE,
  NOTIF_SET_USER_LAST_PAGE,
  NOTIF_CLEAR_USER_PAGINATED,
  NOTIF_SET_USER_SCROLL_POSITION,
} from 'store/types';

export const storeAdminLatestNotif = (data) => {
  return {
    type: NOTIF_SET_ADMIN_LATEST,
    payload: data,
  };
};

export const storeAdminDataNotif = (data) => {
  return {
    type: NOTIF_SET_ADMIN_DATA,
    payload: data,
  };
};

export const storeAdminUnreadNotif = (data) => {
  return {
    type: NOTIF_SET_ADMIN_UNREAD,
    payload: data,
  };
};

export const storeAdminPaginatedNotif = (data) => {
  return {
    type: NOTIF_SET_ADMIN_PAGINATED_DATA,
    payload: data,
  };
};

export const storeAdminCurrentPage = (page) => {
  return {
    type: NOTIF_SET_ADMIN_CURRENT_PAGE,
    payload: page,
  };
};

export const storeAdminLastPage = (page) => {
  return {
    type: NOTIF_SET_ADMIN_LAST_PAGE,
    payload: page,
  };
};

export const storeAdminScrollPosition = (position) => {
  return {
    type: NOTIF_SET_ADMIN_SCROLL_POSITION,
    payload: position,
  };
};

export const storeUserLatestNotif = (data) => {
  return {
    type: NOTIF_SET_USER_LATEST,
    payload: data,
  };
};

export const storeUserDataNotif = (data) => {
  return {
    type: NOTIF_SET_USER_DATA,
    payload: data,
  };
};

export const storeUserUnreadNotif = (data) => {
  return {
    type: NOTIF_SET_USER_UNREAD,
    payload: data,
  };
};

export const storeUserPaginatedNotif = (data) => {
  return {
    type: NOTIF_SET_USER_PAGINATED_DATA,
    payload: data,
  };
};

export const storeUserCurrentPage = (page) => {
  return {
    type: NOTIF_SET_USER_CURRENT_PAGE,
    payload: page,
  };
};

export const storeUserLastPage = (page) => {
  return {
    type: NOTIF_SET_USER_LAST_PAGE,
    payload: page,
  };
};

export const clearUserPaginatedNotif = () => {
  return {
    type: NOTIF_CLEAR_USER_PAGINATED,
  };
};

export const storeUserScrollPosition = (position) => {
  return {
    type: NOTIF_SET_USER_SCROLL_POSITION,
    payload: position,
  };
};
